import { TransformsList } from 'cio/utils/analytics/transforms';
import { getWarehouseDestinationName } from 'cio/utils/warehouse';

const Transforms: TransformsList = {
  withType(data) {
    return {
      Type: getWarehouseDestinationName(data?.model?.type),
    };
  },

  destinationViewed(data) {
    if (!data.route) {
      return {};
    }

    return {
      Type: {
        snowflake: 'Snowflake',
        redshift: 'Amazon Redshift',
        bigquery: 'Google BigQuery',
      }[data.route.localName as 'snowflake' | 'redshift' | 'bigquery'],
    };
  },

  exportToggled(data) {
    return {
      Type: getWarehouseDestinationName(data?.model?.type),
      'Export Type': data.exportType,
    };
  },
};

export default Transforms;
